import { AbstractRepository } from '@/repositories/abstract-repository';
import { ReportJobLog } from '@/reports/models/reports';

export class ReportJobLogsRepository extends AbstractRepository<ReportJobLog> {
    readonly endpoint = '/reports/etl-job-logs';
}
